import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { isEmpty, DicVal } from "../../../modules/appLibrary";
import { EDIT_UPDATE_TRACKING_PANEL_TYPES } from "../constants";
import { perfCountRender } from "../../../modules/perfTrace";

// 品番マスタ入力フォームのセクション一覧描画。状態は持たず、すべて props 経由で受け取る。
// 本文は HinbanMaster.js から移設したもの。
const HinbanMasterEntryForm = (props) => {
    perfCountRender("EntryFormLayout");
    const {
        displayPanels,
        EntrybodyRef,
        onDragEnter,
        sectionEditable,
        sectionBodyLocked,
        sectionDisplaySetting,
        sectionKey,
        panelhidden,
        setSectionRef,
        sectionHeaderFieldsetRefs,
        renderDetailSectionHeaderInline,
        layoutlock,
        entrylock,
        SetBaseField,
        isKakousijiPanel,
        sectionButtonRefs,
        toggleSectionEdit,
        sectionclose,
        showpanel,
        isKakousijiHeaderPanel,
        kakousijiSummaryBand,
        isKakousijiSijisuPanel,
        kakousijiSijisuActionArea,
        isKakousijiFukushizaiListPanel,
        kakousijiFukushizaiListActionArea,
        isKakousijiSozaiMeisaiPanel,
        kakousijiSozaiMeisaiActionArea,
        isKakousijiFuzokuMeisaiPanel,
        kakousijiFuzokuMeisaiActionArea,
        isKakousijiFukushizaiBasePanel,
        kakousijiFukushizaiBaseActionArea,
        isKakousijiQualityBasePanel,
        kakousijiQualityBaseActionArea,
        isKakousijiSoseiPanel,
        renderKakousijiSoseiActionArea,
        sectionFieldsetRefs,
        memoizedContents,
        sectionOverlayRefs,
        kakousijiModeButtons,
        isKakousijiModeAnchorPanel,
        isDetailHeaderPanel,
        renderKakousijiDemandHeader,
        isKakousijiDemandPanel,
        isHinbanGenkaPanel,
        isSustainableDesignPanel,
        renderSustainablePreviewPanel,
        sectionEditInfo,
        showKakousijiSectionEditButton,
        kakousijiSectionEditActive,
        kakousijiSectionEditInfoPanelType,
        hideKakousijiModeAnchorBodyByMode,
        kakousijiFukushizaiTabBarArea,
        kakousijiQualityTabBarArea,
        kakousijiFukushizaiScopePanelTypes,
        kakousijiQualityScopePanelTypes,
        kakousijiQualityWarningPanelType
    } = props;
    const isProductOrderHeaderPanel = (panelInfo) => String(DicVal(panelInfo, 'type', '')).trim() === '140';
    return (
        <div className="hinban-entry-body" ref={EntrybodyRef} onDragEnter={onDragEnter}>
            {(() => {
            const renderPanelSection = (p) => {
                const editable = sectionEditable(p);
                const isHinbanGenka = isHinbanGenkaPanel(p);
                const bodyLocked = sectionBodyLocked(p);
                const sectionSetting = sectionDisplaySetting(p);
                const isKakousijiHeader = isKakousijiHeaderPanel(p);
                const isKakousijiModeAnchor = isKakousijiModeAnchorPanel(p);
                const hidden = panelhidden(p);
                const hideKakousijiModeAnchorBody = isKakousijiModeAnchor && (isEmpty(kakousijiModeButtons) || hideKakousijiModeAnchorBodyByMode);
                const sectionType = String(DicVal(p, 'type', '')).trim();
                const isEditTrackedSection = EDIT_UPDATE_TRACKING_PANEL_TYPES.includes(sectionType);
                const showKakousijiEditButton = showKakousijiSectionEditButton(p);
                const panelSectionEditInfo = DicVal(sectionEditInfo, sectionType, {});
                const showKakousijiSoseiCalcButton = isKakousijiSoseiPanel(p);
                const headerActionReservedWidth = (showKakousijiEditButton ? 132 : 0) + (showKakousijiSoseiCalcButton ? 88 : 0);
                const showSectionEditText = !showKakousijiEditButton || sectionType === kakousijiSectionEditInfoPanelType;
                const sectionEditText = isEditTrackedSection && showSectionEditText && !isEmpty(panelSectionEditInfo) ? [panelSectionEditInfo.user, panelSectionEditInfo.update].filter(v => !isEmpty(v)).join('  ') : '';
                return (
                    <React.Fragment key={sectionKey(p) + '_wrap'}>
                        {!isKakousijiModeAnchor || hidden ? null :
                            <Box display='flex' justifyContent='space-around' alignItems='center' padding='5px'>
                                <div className="hinban-mode-anchor-band">
                                    {kakousijiSummaryBand}
                                    {isEmpty(kakousijiModeButtons) ? null : (
                                        <Paper className="hinban-mode-buttons-paper">
                                            {kakousijiModeButtons}
                                        </Paper>
                                    )}
                                </div>
                            </Box>
                        }
                        <Box
                            key={sectionKey(p)}
                            display={hidden || hideKakousijiModeAnchorBody ? 'none' : 'flex'}
                            justifyContent='space-around'
                            alignItems='center'
                            padding='5px'
                        >
                            <Paper className="hinban-section-paper">
                                {isKakousijiHeader ? null :
                                    <div className="hinban-section-header-row" style={{ paddingRight: headerActionReservedWidth, minHeight: headerActionReservedWidth > 0 ? 34 : undefined }}>
                                        {isHinbanGenka ? (
                                            <span className="hinban-section-title">
                                                <span className="hinban-section-title-accent"></span>
                                                <span>{p.name}</span>
                                            </span>
                                        ) : isSustainableDesignPanel(p) ? (
                                            <span>{p.name}</span>
                                        ) : (
                                            <span>
                                                {p.name} - <span className="hinban-section-subtitle">{p.name2}</span>
                                            </span>
                                        )}
                                        {!isProductOrderHeaderPanel(p) ? null :
                                            <Button
                                                type='button'
                                                variant='contained'
                                                size='small'
                                                disabled={entrylock}
                                                onClick={() => window.open('about:blank', '_blank')}
                                                className="hinban-order-button hinban-order-button--sm"
                                            >
                                                製商品発注
                                            </Button>
                                        }
                                        {!isDetailHeaderPanel(p) ? null :
                                            <fieldset
                                                disabled={sectionBodyLocked(p)}
                                                ref={(node) => setSectionRef(sectionHeaderFieldsetRefs, sectionKey(p), node)}
                                                className="hinban-section-header-fieldset"
                                            >
                                                {renderDetailSectionHeaderInline(p, false)}
                                            </fieldset>
                                        }
                                        <div className="hinban-section-header-actions">
                                            {!sectionSetting.showSettings || p.id !== '0' || layoutlock ? null :
                                                <div title='項目設定'>
                                                    <IconButton size='small' onClick={() => SetBaseField(p.type)} disabled={entrylock || (sectionSetting.showEdit && !editable)}>
                                                        <Icon className="hinban-icon-16">settings_applications</Icon>
                                                    </IconButton>
                                                </div>
                                            }
                                            {(!showKakousijiEditButton && (!sectionSetting.showEdit || isKakousijiPanel(p))) || !isEditTrackedSection || !editable || isEmpty(sectionEditText) ? null :
                                                <span
                                                    title={sectionEditText}
                                                    className="hinban-section-edit-info"
                                                >
                                                    {sectionEditText}
                                                </span>
                                            }
                                            {!sectionSetting.showEdit || isKakousijiPanel(p) ? null :
                                                <Button
                                                    type='button'
                                                    ref={(node) => setSectionRef(sectionButtonRefs, sectionKey(p), node)}
                                                    variant={editable ? 'contained' : 'outlined'}
                                                    size='small'
                                                    onClick={() => toggleSectionEdit(p)}
                                                    disabled={entrylock}
                                                    className="hinban-section-edit-button"
                                                >
                                                    {editable ? '編集可' : '編集不可'}
                                                </Button>
                                            }
                                            {!showKakousijiEditButton ? null :
                                                <Button
                                                    type='button'
                                                    ref={(node) => setSectionRef(sectionButtonRefs, sectionKey(p), node)}
                                                    variant='contained'
                                                    size='small'
                                                    onClick={() => toggleSectionEdit(p)}
                                                    disabled={entrylock || kakousijiSectionEditActive}
                                                    className="hinban-kakousiji-edit-button"
                                                >
                                                    {'加工指示編集'}
                                                </Button>
                                            }
                                            {!isProductOrderHeaderPanel(p) ? null :
                                            <Button
                                                    type='button'
                                                    variant='contained'
                                                    size='small'
                                                    disabled={entrylock}
                                                    onClick={() => window.open('about:blank', '_blank')}
                                                    className="hinban-order-button"
                                                >
                                                    製商品発注
                                                </Button>
                                            }
                                            {!showKakousijiSoseiCalcButton ? null : renderKakousijiSoseiActionArea(p, true)}
                                            {layoutlock || sectionclose || !sectionSetting.showClose ? null :
                                                <IconButton size='small' onClick={() => showpanel(p.id, p.type, false)}>
                                                    <Icon className="hinban-icon-16">close</Icon>
                                                </IconButton>
                                            }
                                        </div>
                                    </div>
                                }
                                {isKakousijiSijisuPanel(p) ? kakousijiSijisuActionArea : null}
                                {isKakousijiSozaiMeisaiPanel(p) ? kakousijiSozaiMeisaiActionArea : null}
                                {isKakousijiFuzokuMeisaiPanel(p) ? kakousijiFuzokuMeisaiActionArea : null}
                                {isKakousijiFukushizaiListPanel(p) ? kakousijiFukushizaiListActionArea : null}
                                {isKakousijiFukushizaiBasePanel(p) ? kakousijiFukushizaiBaseActionArea : null}
                                {isKakousijiQualityBasePanel(p) ? kakousijiQualityBaseActionArea : null}
                                {isKakousijiDemandPanel(p) ? renderKakousijiDemandHeader(p) : null}
                                {isSustainableDesignPanel(p) ? renderSustainablePreviewPanel(p) : null}
                                <div className="hinban-section-body">
                                    <fieldset
                                        disabled={bodyLocked}
                                        ref={(node) => setSectionRef(sectionFieldsetRefs, sectionKey(p), node)}
                                        className="hinban-section-body-fieldset"
                                    >
                                        {memoizedContents[sectionKey(p)]}
                                    </fieldset>
                                    {!bodyLocked ? null :
                                        <div
                                            ref={(node) => setSectionRef(sectionOverlayRefs, sectionKey(p), node)}
                                            className="hinban-section-lock-overlay"
                                        />
                                    }
                                </div>
                            </Paper>
                        </Box>
                    </React.Fragment>
                );
            };
            // 副資材/品質表示のアイテムタブ連動スコープを枠で囲む(加工指示画面と同じ構造)。
            // 品質スコープの先頭には品表注意パネル、続けてタブバー(アイテム/グループ/製品カラー)を置く。
            const scopeOf = (panelInfo) => {
                const panelType = String(DicVal(panelInfo, 'type', '')).trim();
                if ((kakousijiFukushizaiScopePanelTypes || []).includes(panelType)) return 'fukushizai';
                if ((kakousijiQualityScopePanelTypes || []).includes(panelType)) return 'quality';
                return null;
            };
            const warningPanel = displayPanels.find((panelInfo) =>
                String(DicVal(panelInfo, 'type', '')).trim() === kakousijiQualityWarningPanelType) || null;
            const renderedSections = [];
            let scopeBuffer = [];
            let scopeVisibleCount = 0;
            let currentScope = null;
            const flushScope = () => {
                if (scopeBuffer.length === 0) { currentScope = null; return; }
                const domain = currentScope;
                // スコープ内の全パネルが非表示(受注数/納品予定数モード等)のときは
                // 枠線・タブバー・品表注意を出さない(加工指示画面と同じ挙動)。
                // ラッパー div 自体は常に残す: 枠内⇔枠外の付け替えをすると
                // セクション(AG Grid)が再マウントされ表示データが失われるため。
                const scopeVisible = scopeVisibleCount !== 0;
                renderedSections.push(
                    <div
                        key={'hinban-itemgroup-scope-' + domain}
                        className={scopeVisible ? 'kakousiji-itemgroup-scope hinban-itemgroup-scope' : 'hinban-itemgroup-scope-hidden'}
                    >
                        {scopeVisible && domain === 'quality' && warningPanel !== null ?
                            <div className="kakousiji-quality-warning-header">
                                {memoizedContents[sectionKey(warningPanel)]}
                            </div>
                            : null}
                        {scopeVisible ? (domain === 'fukushizai' ? kakousijiFukushizaiTabBarArea : kakousijiQualityTabBarArea) : null}
                        {scopeBuffer}
                    </div>
                );
                scopeBuffer = [];
                scopeVisibleCount = 0;
                currentScope = null;
            };
            displayPanels.forEach((p) => {
                const panelType = String(DicVal(p, 'type', '')).trim();
                // 品表注意はスコープ枠先頭で表示するため通常フローから除外する
                if (panelType === kakousijiQualityWarningPanelType) return;
                const scope = scopeOf(p);
                if (scope === null) {
                    flushScope();
                    renderedSections.push(renderPanelSection(p));
                    return;
                }
                if (currentScope !== null && currentScope !== scope) flushScope();
                currentScope = scope;
                scopeBuffer.push(renderPanelSection(p));
                if (!panelhidden(p)) scopeVisibleCount += 1;
            });
            flushScope();
            return renderedSections;
            })()}
        </div>
    );
};

export default HinbanMasterEntryForm;
